export const mutationNames = {
  SET_MAIN_MENU_OPEN: 'UI/mainMenuOpen',
  TOGGLE_MAIN_MENU: 'UI/toggleMenuOpen',
  SET_FEATURE_FLAGS: 'UI/setFeatureFlags',
};
